import ApplicationSerializer from './application';

export default class QuestionnaireSerializer extends ApplicationSerializer {
  attrs = {
    updatedAt: {
      serialize: false,
    },
  };
}
